export default __webpack_public_path__ + "static/media/location.b95d427a.gif";